// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-container {
  font-size: 0.6rem;
}

.user-button {
  --border-radius: 30px;
  --background: #2E7D32 ;
}

.address-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  line-height: 1.5;
}

.address-label {
  white-space: nowrap;
  color: red;
}

.address-text {
  margin-left: 5px;
  white-space: pre-line; /* Ensures the text follows as multiline if it exceeds the width */
}

.header-row {
  background: white;
  padding: 15px 10px;
  display: flex;
  align-items: center;
}

.logo-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.logo-image {
  object-fit: scale-down;
}

.business-info-col {
  padding: 0px 10px;
  text-align: left;
}

.business-name {
  font-size: 0.8rem;
  font-weight: bold;
  text-align: left;
}

.login-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-button {
  width: 100%;
  max-width: 100px; /* Limit maximum width */
  min-width: 70px; /* Ensure minimum width */
  padding: 0 5px; /* Reduce padding */
  height: 36px; /* Fixed height */
  font-weight: bold;
  text-transform: capitalize;
}

/* Responsive adjustments */
@media (max-width: 360px) {
  .header-row {
    padding: 10px 5px;
  }
  .user-button {
    font-size: 0.7rem;
    min-width: 60px;
    padding: 0 3px;
  }
}
@media (min-width: 361px) and (max-width: 400px) {
  .user-button {
    font-size: 0.8rem;
    min-width: 70px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEE;EACE,qBAAA;EACA,sBAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,mBAAA;EACA,UAAA;AACJ;;AAEE;EACE,gBAAA;EACA,qBAAA,EAAA,kEAAA;AACJ;;AAEE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AAEE;EACE,sBAAA;AACJ;;AAEE;EACE,iBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEE;EACE,WAAA;EACA,gBAAA,EAAA,wBAAA;EACA,eAAA,EAAA,yBAAA;EACA,cAAA,EAAA,mBAAA;EACA,YAAA,EAAA,iBAAA;EACA,iBAAA;EACA,0BAAA;AACJ;;AAEE,2BAAA;AACA;EACE;IACE,iBAAA;EACJ;EAEE;IACE,iBAAA;IACA,eAAA;IACA,cAAA;EAAJ;AACF;AAGE;EACE;IACE,iBAAA;IACA,eAAA;EADJ;AACF","sourcesContent":[".info-container {\r\n    font-size: 0.6rem;\r\n  }\r\n  \r\n  .user-button {\r\n    --border-radius : 30px;\r\n    --background : #2E7D32\r\n  }\r\n\r\n  .address-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    line-height: 1.5;\r\n  }\r\n\r\n  .address-label {\r\n    white-space: nowrap;\r\n    color: red;\r\n  }\r\n\r\n  .address-text {\r\n    margin-left: 5px;\r\n    white-space: pre-line; /* Ensures the text follows as multiline if it exceeds the width */\r\n  }\r\n\r\n  .header-row {\r\n    background: white; \r\n    padding: 15px 10px;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .logo-col {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0;\r\n  }\r\n\r\n  .logo-image {\r\n    object-fit: scale-down; \r\n  }\r\n\r\n  .business-info-col {\r\n    padding: 0px 10px; \r\n    text-align: left;\r\n  }\r\n\r\n  .business-name {\r\n    font-size: 0.8rem;\r\n    font-weight: bold;\r\n    text-align: left;\r\n  }\r\n\r\n  .login-col {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .user-button {\r\n    width: 100%;\r\n    max-width: 100px; /* Limit maximum width */\r\n    min-width: 70px; /* Ensure minimum width */\r\n    padding: 0 5px; /* Reduce padding */\r\n    height: 36px; /* Fixed height */\r\n    font-weight: bold;\r\n    text-transform: capitalize;\r\n  }\r\n\r\n  /* Responsive adjustments */\r\n  @media (max-width: 360px) {\r\n    .header-row {\r\n      padding: 10px 5px;\r\n    }\r\n\r\n    .user-button {\r\n      font-size: 0.7rem;\r\n      min-width: 60px;\r\n      padding: 0 3px;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 361px) and (max-width: 400px) {\r\n    .user-button {\r\n      font-size: 0.8rem;\r\n      min-width: 70px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
